import { render, staticRenderFns } from "./dropOffBill.vue?vue&type=template&id=bdec9706&scoped=true"
import script from "./dropOffBill.vue?vue&type=script&lang=js"
export * from "./dropOffBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec9706",
  null
  
)

export default component.exports